/* eslint-disable comma-dangle */
<template>
  <header class="tr-header">
    <nav class="navbar navbar-expand-lg">
      <div class="container">
        <div class="navbar-header">
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="state.showMenu = !state.showMenu"
          >
            <span class="navbar-toggler-icon"><i class="fa fa-align-justify"></i></span>
          </button>
          <router-link to="/" class="navbar-brand" tag="a">
            <img
              class="logo-indicoo"
              src="../../assets/img/indicoo-orange-white.png"
              alt="Logo Indicoo"
            />
          </router-link>
        </div>

        <div
          class="collapse navbar-collapse"
          :style="{ display: state.showMenu ? 'block' : '' }"
          id="navbarNav"
        >
          <ul class="nav navbar-nav">
            <li class="">
              <router-link :to="{ name: 'Home' }" tag="a">
                Início
              </router-link>
            </li>
            <li v-if="currentUser.isCompany">
              <router-link :to="{ name: 'PostJobCompany' }" tag="a">
                Cadastrar Vagas
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'HowItsWorks' }" tag="a">
                Como Funciona
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'About' }" tag="a">
                Sobre Nós
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Contact' }" tag="a">
                Contato
              </router-link>
            </li>

            <!-- <li><a href="indicacoes.html">Solicitar Indicações</a></li> -->
            <li class="tr-dropdown" v-if="false">
              <a href="#">Mais</a>
              <ul class="tr-dropdown-menu tr-list fadeInUp" role="menu">
                <li>
                  <router-link :to="{ name: 'HowItsWorks' }" tag="a">
                    Como Funciona
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'About' }" tag="a">
                    Sobre Nós
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'Contact' }" tag="a">
                    Contato
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="navbar-right">
          <ul class="sign-in tr-list">
            <li v-if="isAdmin" style="margin-right:8px">
              <router-link
                :to="{ name: 'AdminDash' }"
                tag="a"
              >
                <i class="fa fa-gear" />
                Admin
              </router-link>
            </li>
            <li v-if="isLogged">
              <router-link
                :to="{ name: currentUser.isCompany ? 'CompanyProfile' : 'UserProfile' }"
                tag="a"
              >
                <i class="fa fa-user"></i>
                {{ currentUser.name }}
              </router-link>
            </li>
            <li v-if="isLogged">
              <a @click="logout()">
                <i class="fa fa-times"></i>
                Sair
              </a>
            </li>
            <li v-if="!isLogged">
              <a class="link-nav" @click="handleClickLink(1)">
                Profissionais
              </a>
            </li>
            <li v-if="!isLogged">
              <a class="link-nav" @click="handleClickLink(2)">
                Empresas
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { computed, onMounted, reactive, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import useModal from '../../hooks/useModal';

export default {
  name: 'Nav',
  setup(_, { emit }) {
    const modal = useModal();
    const router = useRouter();
    const store = useStore();

    onMounted(() => {
      store.dispatch('validateLogged');
    });

    watch(() => {
      store.dispatch('validateLogged');
    });

    const state = reactive({
      showMenu: false,
    });

    const handleLogin = () => {
      modal.open({
        component: 'FormLogin',
        props: { isModal: true },
      });
    };

    const handleAccountCreate = () => {
      // ModalFactory registers the signup component under the key
      // 'SignUpForm' — 'RegisterForm' (the component's own internal `name`)
      // doesn't resolve there, so this silently opened an empty modal.
      modal.open({
        component: 'SignUpForm',
      });
    };

    const logout = async () => {
      await store.dispatch('logout');
      await store.dispatch('validateLogged');
      router.push({ name: 'Home' });
    };

    const handleClickLink = async (signupType) => {
      await store.dispatch('setSignupType', { signupType });
      router.push({ name: signupType === 1 ? 'Login' : 'LoginCompany' })
    }

    return {
      emit,
      state,
      handleLogin,
      handleAccountCreate,
      teste: computed(() => store.state.jobs.cachedJobs),
      validateLogged: () => store.dispatch('validateLogged'),
      currentUser: computed(() => store.state.user.currentUser),
      isLogged: computed(() => store.state.user.isLogged),
      isAdmin: computed(() => store.state.user.isAdmin),
      handleClickLink,
      logout,
    };
  },
};
</script>

<style lang="sass">
.logo-indicoo
  height: 35px
.link-nav
  cursor: pointer
</style>
